"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _CalloutMediaElement = _interopRequireDefault(require("../common/Callout/CalloutMediaElement"));
var _HBCalloutCard = require("./HBCalloutCard.styles");
var _HBCloseButton = _interopRequireDefault(require("../HBCloseButton/HBCloseButton"));
var _SizeProvider = require("../common/SizeProvider");
var _HBCalloutFooter = require("../HBCalloutFooter/HBCalloutFooter");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function useHBCalloutCardTheme() {
  return (0, _styledComponents.useTheme)();
}
function CalloutCardContent(_ref) {
  var title = _ref.title,
    body = _ref.body,
    steps = _ref.steps,
    currentStep = _ref.currentStep;
  var _useHBCalloutCardThem = useHBCalloutCardTheme(),
    size = _useHBCalloutCardThem.size;
  var _title, _body;
  if (steps) {
    _title = steps[currentStep].title;
    _body = steps[currentStep].body;
  } else {
    _title = title;
    _body = body;
  }
  return /*#__PURE__*/_react["default"].createElement(_HBCalloutCard.CardTitleAndBodyContainer, null, /*#__PURE__*/_react["default"].createElement(_HBCalloutCard.CardTitle, {
    type: _HBCalloutCard.sizeStyles[size].title
  }, _title), /*#__PURE__*/_react["default"].createElement(_HBCalloutCard.CardBody, {
    type: _HBCalloutCard.sizeStyles[size].body
  }, _body));
}
var HBCalloutCard = function HBCalloutCard(_ref2) {
  var title = _ref2.title,
    body = _ref2.body,
    size = _ref2.size,
    layout = _ref2.layout,
    onDismiss = _ref2.onDismiss,
    mediaPath = _ref2.mediaPath,
    _ref2$imageFit = _ref2.imageFit,
    imageFit = _ref2$imageFit === void 0 ? 'cover' : _ref2$imageFit,
    _ref2$imageWidth = _ref2.imageWidth,
    imageWidth = _ref2$imageWidth === void 0 ? 200 : _ref2$imageWidth,
    withImagePadding = _ref2.withImagePadding,
    footerProps = _ref2.footerProps,
    steps = _ref2.steps,
    onImageClick = _ref2.onImageClick,
    _ref2$autoRotate = _ref2.autoRotate,
    autoRotate = _ref2$autoRotate === void 0 ? false : _ref2$autoRotate,
    _ref2$autoRotateInter = _ref2.autoRotateInterval,
    autoRotateInterval = _ref2$autoRotateInter === void 0 ? 5000 : _ref2$autoRotateInter,
    _ref2$autoRotateResum = _ref2.autoRotateResumeDelay,
    autoRotateResumeDelay = _ref2$autoRotateResum === void 0 ? 15000 : _ref2$autoRotateResum;
  // this is only relevant if steps are passed
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currentStep = _useState2[0],
    setCurrentStep = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement(_SizeProvider.SizeProvider, {
    size: size,
    additionalThemeProps: {
      layout: layout,
      hasImage: !!mediaPath,
      withImagePadding: withImagePadding
    }
  }, /*#__PURE__*/_react["default"].createElement(_HBCalloutCard.CardContainer, null, /*#__PURE__*/_react["default"].createElement(_CalloutMediaElement["default"], {
    imageFit: imageFit,
    mediaPath: mediaPath,
    width: imageWidth,
    layout: layout,
    withImagePadding: withImagePadding,
    onClick: onImageClick,
    currentStep: currentStep,
    steps: steps
  }), /*#__PURE__*/_react["default"].createElement(_HBCalloutCard.CardContentContainer, null, /*#__PURE__*/_react["default"].createElement(CalloutCardContent, {
    title: title,
    body: body,
    steps: steps,
    currentStep: currentStep
  }), /*#__PURE__*/_react["default"].createElement(_HBCalloutFooter.HBCalloutFooter, (0, _extends2["default"])({}, footerProps, {
    currentStep: currentStep,
    setCurrentStep: setCurrentStep,
    steps: steps,
    autoRotate: autoRotate,
    autoRotateInterval: autoRotateInterval,
    autoRotateResumeDelay: autoRotateResumeDelay
  }))), onDismiss && /*#__PURE__*/_react["default"].createElement(_HBCloseButton["default"], {
    size: "xs",
    theme: "dark",
    distance: 2,
    testIdName: "dismiss-button",
    onClick: onDismiss
  })));
};
var _default = exports["default"] = HBCalloutCard;
//# sourceMappingURL=HBCalloutCard.js.map